// extracted by mini-css-extract-plugin
export default {"timer":"timer_timer__foJ+W","times":"timer_times__VrXrS","timerControl":"timer_timerControl__l62JU"};